import { locateAttr, locateID } from "@xbs/lib-dom";
import { isSameId } from "../helpers";
import { elementsIds } from "../constants";
export function selection(node, config) {
    if (config.readonly) {
        return;
    }
    let pressedElem;
    const { api } = config;
    const handleDown = (e) => {
        pressedElem = e.target;
    };
    api.on("select-card", ({ id }) => {
        if (!pressedElem) {
            // wait for editor animation
            setTimeout(() => {
                api.exec("scroll", {
                    to: "card",
                    id,
                });
            }, 100);
        }
    });
    const handleUp = (e) => {
        if (!pressedElem) {
            return;
        }
        const ignoreSelection = locateAttr(e.target, "data-ignore-selection");
        if (ignoreSelection) {
            return;
        }
        const itemId = locateID(pressedElem, "data-drag-item");
        const dataId = locateID(pressedElem, "data-kanban-id");
        const groupMode = e.metaKey || e.ctrlKey;
        const rangeMode = e.shiftKey;
        // prevent selection reset after drag&drop
        const isSameEl = pressedElem === e.target;
        if (isSameEl && dataId !== elementsIds.editor) {
            handleSelectAction({
                itemId,
                groupMode,
                rangeMode,
                api,
            });
        }
        pressedElem = null;
    };
    node.addEventListener("mousedown", handleDown);
    node.addEventListener("mouseup", handleUp);
    return {
        destroy() {
            node.removeEventListener("mousedown", handleDown);
            node.removeEventListener("mouseup", handleUp);
        },
    };
}
function handleSelectAction(data) {
    const { itemId, groupMode, rangeMode, api } = data;
    const { cardsMap, columnKey } = api.getState();
    const { selected } = api.getState();
    if (!itemId && selected?.length) {
        api.exec("unselect-card", {
            id: null,
        });
        return;
    }
    if (rangeMode && selected?.length) {
        const card = api.getCard(itemId);
        const lastSelectedCard = api.getCard(selected[selected.length - 1]);
        const isInSameColumn = isSameColumn(card, lastSelectedCard, columnKey);
        if (isInSameColumn) {
            const columnCards = Object.keys(cardsMap)
                .filter(key => getColumnFromAreaId(key) === card[columnKey])
                .reduce((acc, key) => {
                const cards = cardsMap[key];
                return acc.concat(cards);
            }, []);
            const itemIndex = columnCards.findIndex(card => isSameId(card.id, itemId));
            const lastSelectedIndex = columnCards.findIndex(card => isSameId(card.id, lastSelectedCard?.id));
            const startIndex = Math.min(itemIndex, lastSelectedIndex);
            const endIndex = Math.max(itemIndex, lastSelectedIndex);
            columnCards.slice(startIndex, endIndex + 1).forEach(c => {
                if (selected.indexOf(c.id) === -1) {
                    api.exec("select-card", {
                        id: c.id,
                        groupMode: true,
                    });
                }
            });
            return;
        }
    }
    api.exec("select-card", {
        id: itemId,
        groupMode,
    });
}
function isSameColumn(first, second, columnKey) {
    if (!first || !second || !columnKey) {
        return false;
    }
    return isSameId(first[columnKey], second[columnKey]);
}
function getColumnFromAreaId(areaId) {
    return areaId.split(":")[0];
}
//# sourceMappingURL=selection.js.map